import { EvoluaApiError } from "@evolua/api-client";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { handleGlobalApiError } from "./forbidden.js";

function errorCode(error: unknown): string | undefined {
  if (error instanceof EvoluaApiError) return error.problem.code;
  return undefined;
}

function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof EvoluaApiError && (error.status === 401 || error.status === 403)) {
    return false;
  }
  const code = errorCode(error);
  const transient =
    code === "NETWORK_ERROR" ||
    code === "TIMEOUT" ||
    (error instanceof EvoluaApiError &&
      (error.status === 502 || error.status === 503 || error.status === 504));
  if (transient) return failureCount < 2;
  return failureCount < 1;
}

function retryDelay(attemptIndex: number): number {
  return Math.min(2000 * (attemptIndex + 1), 6000);
}

/** QueryClient padrão do portal: cache curto, 401/403 sem retry, 403 global. */
export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: shouldRetry,
        retryDelay,
        refetchOnWindowFocus: true,
      },
      mutations: {
        retry: false,
      },
    },
    queryCache: new QueryCache({
      onError: (error) => {
        handleGlobalApiError(error);
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        handleGlobalApiError(error);
      },
    }),
  });
}
